import Authentic from 'products/global/assets/img/join-us/who/Authentic.gif';
import DoRight from 'products/global/assets/img/join-us/who/DoRight.gif';
import MakeMIstakes from 'products/global/assets/img/join-us/who/MakeMistakes.gif';
import SocialSafetyNet from 'products/global/assets/img/join-us/who/SocialSafetyNet.gif';

export const ITEMS = [
  {
    id: 1,
    description: 'Wants to help build a global social safety net on the Internet',
    illustration: SocialSafetyNet
  },
  {
    id: 2,
    description: 'Thinks for themselves instead of copying others',
    illustration: Authentic
  },
  {
    id: 3,
    description: 'Is eager to try new things, even at the risk of failure',
    illustration: MakeMIstakes
  },
  {
    id: 4,
    description: 'Has strong integrity and does the right thing',
    illustration: DoRight
  }
];
